import type {StateCreator} from 'zustand'
import type {ChangeGroupPayload} from '../../types/group-types'

export type ChangeGroupGenerationSliceOpts = {
  changeGroupGeneration: ChangeGroupPayload
  showChangeGroupPreference: boolean
}
export type ChangeGroupGenerationSlice = {
  changeGroupGeneration: ChangeGroupPayload
  showChangeGroupPreference: boolean
  changeGroupGenerationActions: {
    updateChangeGroupGeneration: (newVal: ChangeGroupPayload) => void
    updateChangeGroupPreference: (newVal: boolean) => void
  }
}

export const createChangeGroupGenerationSlice =
  ({
    changeGroupGeneration: {
      canAccessChangeGroups,
      changeGroups,
      latestChangeGroupOrchestration,
      changeGroupGenerationChannel,
      unavailableReason,
    },
    showChangeGroupPreference,
  }: ChangeGroupGenerationSliceOpts): StateCreator<
    ChangeGroupGenerationSlice,
    [['zustand/devtools', never]],
    [],
    ChangeGroupGenerationSlice
  > =>
  set => {
    return {
      changeGroupGeneration: {
        canAccessChangeGroups,
        changeGroups,
        latestChangeGroupOrchestration,
        changeGroupGenerationChannel,
        unavailableReason,
      },
      showChangeGroupPreference,
      changeGroupGenerationActions: {
        updateChangeGroupGeneration: (newVal: ChangeGroupPayload) =>
          set(
            state => ({
              changeGroupGeneration: {
                ...state.changeGroupGeneration,
                ...newVal,
              },
              showChangeGroupPreference: state.showChangeGroupPreference,
            }),
            undefined,
            'updateChangeGroupGeneration',
          ),
        updateChangeGroupPreference: (newVal: boolean) =>
          set(
            state => ({
              changeGroupGeneration: state.changeGroupGeneration,
              showChangeGroupPreference: newVal,
            }),
            undefined,
            'updateChangeGroupPreference',
          ),
      },
    }
  }
